import { XIcon } from "lucide-react";
import { Button } from "react-aria-components";
import { composeTailwindRenderProps, focusRing } from "../generic/utils";

type Props = {
  label: string;
  onRemove: () => void;
};

export function ListItem({ label, onRemove }: Props) {
  return (
    <li className="border-theme-outline-variant flex items-center justify-between gap-x-1 rounded-sm border p-4">
      <span className="text-theme-on-background text-[11px] font-bold">
        {label}
      </span>
      <Button
        onPress={onRemove}
        className={composeTailwindRenderProps(
          focusRing,
          "text-theme-on-background rounded-xs p-0.5 hover:opacity-90",
        )}
        type="button"
      >
        <XIcon className="size-4 cursor-pointer" />
      </Button>
    </li>
  );
}
